<template>
    <div>
        <!-- 底部开始 -->
        <footer>
            <div class="footerwrap clearfix marT">
                <!-- <div class="size">团车网已经帮助<em class="redsize">36万</em>团友实现低价购车,累计节省近<em class="redsize">11亿</em>元</div> -->
                <div class="footer-tel clearfix">
                    <span class="marT">客服电话：<a href="tel:4001-501-501">4001-501-501</a></span>
                    <span>商务合作：<a href="tel:010-53353905">13121631053</a></span>
                    <span>工作时间：每天9:00-18:00</span>
                </div>
                <div class="footer-btn clearfix">
                    <p class="gray">团车互联网信息服务（北京）有限公司</p>
                    <p class="gray">CopyRight 2009-<span v-text='$moment().format("YYYY")'></span> TuanChe.com All Rights Reserved</p>
                    <p class="gray">京ICP备12044574号-2</p>
                </div>
            </div>
        </footer>
        <div class="topBack"></div>
    </div>
</template>
<style scoped lang="less">
@import "../../../assets/less/common.less";
	/*底部开始*/
.footerwrap{
    text-align: center;
    margin-top:0.352632rem;
 
    background-color:#f0f0f0;
    .size{
          color:#666;
          .px2px(font-size, 24px);
            padding:0 0.2rem;
          .redsize{
            color:#ff7c7c;
          }

    }

    .footer-tel{
         .px2px(font-size, 24px);
        color:#a6a6a6;
        text-align: center;
        position: relative;
        span{
            display: block;
            margin-top: 0.266667rem;
            a{
              color:#a6a6a6;
            }
        }
        .marT{
		    margin-top: 30px;
		}
    }

    .footer-btn{
        .px2px(font-size, 20px);
        margin:0.394737rem 0 0.578947rem 0;
         color:#b5b5b5;
       
    }
    
}
.topBack{
    display: none;
    position: fixed;
    bottom:0.8rem;
    right:0.563158rem;
    width: 1.289474rem;
    height:1.289474rem;
    background-size:100% 100%;
    z-index: 4;
}
	
</style>
<script>
export default {
    name: 'footerComponent',
    data:function() {
        return {
        }
    },
    mounted:function(){
    }
}
</script>



// WEBPACK FOOTER //
// src/components/global/footer/footer.vue